import React, { useState, useMemo } from 'react';
import AdminSearchTable from '../Admin/AdminSearchTable'
import FilterIcon from '../../SVG/Filter';

const PremiumHistorySection = ({ model }) => {
    const allClaims = model?.premiumHistory || [];

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const columns = [
        { label: 'Description', accessor: 'category' },
        { label: 'Entry Date', accessor: 'entryDate' },
        { label: 'Premium', accessor: 'schedPremDisplay' },
        { label: 'Months Paid', accessor: 'monthsPd' },
        { label: 'Paid To Date', accessor: 'paidToDate' },
    ];

    // Filter claims based on date range
    const filteredClaims = useMemo(() => {
        if (!startDate && !endDate) return allClaims;

        return allClaims.filter(claim => {
            const entryDate = new Date(claim.entryDate);
            const start = startDate ? new Date(startDate) : null;
            const end = endDate ? new Date(endDate) : null;

            if (start && end) {
                return entryDate >= start && entryDate <= end;
            } else if (start) {
                return entryDate >= start;
            } else if (end) {
                return entryDate <= end;
            }
            return true;
        });
    }, [allClaims, startDate, endDate]);

    const handleClear = () => {
        setStartDate('');
        setEndDate('');
    };

    return (
        <div className="container container-section" id="claims-history-container">
            {allClaims.length === 0 ? (
                <div className="card notfoundbox rounded-3 shadow-lg">
                    <div className="card-body">
                        <div className="flex-container">
                            <h5>No Premiums Found</h5>
                        </div>
                    </div>
                </div>
            ) : (
                <>
                    <div className="filter-box">
                        <FilterIcon/>
                        <div className="filter-item">
                            <label htmlFor="startDate" className="filterLabel">Start Date</label>
                            <input
                                type="date"
                                id="startDate"
                                className="filterInput"
                                value={startDate}
                                onChange={e => setStartDate(e.target.value)}
                            />
                        </div>
                        <div className="filter-item">
                            <label htmlFor="endDate" className="filterLabel">End Date</label>
                            <input
                                type="date"
                                id="endDate"
                                className="filterInput"
                                value={endDate}
                                onChange={e => setEndDate(e.target.value)}
                            />
                        </div>
                        <div className="filter-item align-end">
                            <button
                                type="button"
                                className="filterButton"
                                onClick={handleClear}
                            >
                                Clear
                            </button>
                        </div>
                    </div>
                    <AdminSearchTable columns={columns} data={filteredClaims} />
                </>
            )}
        </div>
    );
};

export default PremiumHistorySection;
